import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import Toast from "react-bootstrap/Toast";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import FormCreerLot from "./FormCreerLot";
import FormCreerFournisseur from "./FormCreerFournisseur";
import ProfilFournisseur from "./ProfilFournisseur";
import PageAccueil from "./PageAccueil";
import PageAide from "./PageAide";
import * as intchaine from "./interface-chaine";
import AffichageLots from "./AffichageLots";
import AffichageDernierLot from "./AffichageDernierLot";
import PreparerEtAussiAfficherGraphe from "./PreparerEtAussiAfficherGraphe";
import RappelLot from "./RappelLot";
import ChargerLot from "./ChargerLot";
import {DEBUG} from "./utilitaires";


export default function Navigation() {
  const [choixCreerFournisseur, setChoixCreerFournisseur] = useState(false);
  const [choixProfilFournisseur, setChoixProfilFournisseur] = useState(false);
  const [choixCreerLot, setChoixCreerLot] = useState(false);
  const [choixVoirLesLots, setChoixVoirLesLots] = useState(false);
  const [compteFournisseur, setCompteFournisseur] = useState(
    intchaine.accountFournisseur
  );
  const [nomF, setnomF] = useState("");
  const [choixPageAccueil, setChoixPageAccueil] = useState(true);
  const [choixPageAide, setChoixPageAide] = useState(false);
  const [choixDernierLot, setChoixDernierLot] = useState(false);
  const [choixGraphe, setChoixGraphe] = useState(false);
  const [choixRappel, setChoixRappel] = useState(false);
  const [choixCharger, setChoixCharger] = useState(false); 
  
 
  //pour le modal 
  const [show, setShow] = useState(false);
  const [msgModal, setMsgModal] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const [tilt, setTilt] = useState(true) //astuce sans doute inutile pour re-render du modal...

  // on lance la blockchain
  useEffect(() => {
    document.title = "Traceur: la blockchain au service de la traçabilité";
    (async () => {
      try {
        await intchaine.lancer();  //connexion à la blockchain
      } catch {
        setMsgModal("Problème lors de la connexion à la blockchain") 
        setShow(true)
      }
    })();
  }, []);


  //mise à jour du message en haut à droite (nom du fournisseur, compte metamask)
  async function mettreAJourCompteFournisseur() {
    if (!intchaine.accountFournisseur) {
      setMsgModal("Aucun compte n'a été selectionné")
      setShow(true)
    }
    else {
      // intchaine.setFournisseurEstAutorise()
      setCompteFournisseur(intchaine.accountFournisseur);
      setnomF(await intchaine.getNomFournisseur(intchaine.accountFournisseur))
      
    }
  }

  // routage à la main, on cache tout et on montre le composant choisi
  function toutCacher() {
    setChoixCreerLot(false);
    setChoixVoirLesLots(false);
    setChoixCreerFournisseur(false);
    setChoixProfilFournisseur(false);
    setChoixPageAccueil(false);
    setChoixPageAide(false);
    setChoixDernierLot(false);
    setChoixGraphe(false);
    setChoixRappel(false);
    setChoixCharger(false);   
  }

  function handleCreerLot() {
    toutCacher();
    setChoixCreerLot(true);
  }

  function handleDernierLot() {
    toutCacher();
    setChoixDernierLot(true);
  }

  function handleVoirLesLots() {
    toutCacher();
    setChoixVoirLesLots(true);
  }


  function handleCreerFournisseur() {
    toutCacher();
    setChoixCreerFournisseur(true);
  }

  function handleProfilFournisseur() {
    toutCacher();
    setChoixProfilFournisseur(true);
    // setTilt(!tilt)
  }

  function handlePageAccueil() {
    toutCacher();
    setChoixPageAccueil(true);
  }

  function handlePageAide() {
    toutCacher();
    setChoixPageAide(true);
  }

  function handleGraphe() {
    toutCacher();
    setChoixGraphe(true);
  }

  function handleRappel() {
    toutCacher();
    setChoixRappel(true);
  }  

  function handleChargerLot() {
    toutCacher();
    setChoixCharger(true);
  }  

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
        <Container>
          <Navbar.Brand 
          // href="#home"
          >
             <img
              alt="dog"
              src="dogTraceur.png"
              width="30"
              height="30"
              className="d-inline-block align-top"
            />{" "}
            &nbsp;&nbsp;Traceur
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">

            <Nav.Link 
            // href="#link"
              onClick={handlePageAccueil} active={choixPageAccueil}>Accueil</Nav.Link>

              <NavDropdown title="Fournisseur" id="basic-nav-dropdown">
                <NavDropdown.Item
                  // href="#action/3.1"
                   onClick={handleCreerFournisseur}
                >
                  Créer Nouveau Fournisseur
                </NavDropdown.Item>
                <NavDropdown.Item
                  // href="#action/3.2"
                   onClick={handleProfilFournisseur}
                >
                  Voir Profil Fournisseur
                </NavDropdown.Item>
                {/* <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated Link
                </NavDropdown.Item> */}
              </NavDropdown>

              <NavDropdown title="Lots" id="basic-nav-dropdown">
                <NavDropdown.Item 
                // href="#action/3.1" 
                  onClick={handleCreerLot}>
                  Créer Nouveau Lot
                </NavDropdown.Item>

                <NavDropdown.Item 
                // href="#action/3.1" 
                  onClick={handleChargerLot}>
                  Charger Lot
                </NavDropdown.Item>
                
                <NavDropdown.Item 
                // href="#action/3.3" 
                  onClick={handleDernierLot}>
                  Voir Dernier Lot
                </NavDropdown.Item>

                <NavDropdown.Item 
                // href="#action/3.2"
                  onClick={handleVoirLesLots}>
                  Voir Les Lots
                </NavDropdown.Item>

                {/* <NavDropdown.Divider /> */}
                <NavDropdown.Item 
                // href="#action/3.4"
                   onClick={handleGraphe}>
                   Voir Chaîne de Traçabilité
                </NavDropdown.Item>
                <NavDropdown.Item 
                // href="#action/3.4"
                   onClick={handleRappel}>
                   Rappeller Lot
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link 
              // href="#link1" 
                onClick={handlePageAide}>Aide</Nav.Link>
            </Nav>

            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="tooltip-bottom">
                  cliquez pour mettre à jour le compte fournisseur
                </Tooltip>
              }
            >
              <Navbar.Text
                style={{ cursor: "pointer" }}
                onClick={mettreAJourCompteFournisseur}
              >
                <span>
                  fournisseur: {nomF}, compte:&nbsp;
                  {/* "{intchaine.accountFournisseur}" */}
                  "{compteFournisseur}"
                </span>
              </Navbar.Text>
            </OverlayTrigger>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* plusieurs containers pour choisir des dimensions différentes selon les cas */}
      <Container>
        <Row>
          <Col></Col>
          <Col xs={7}>
            <br />
            {choixCreerLot && <FormCreerLot />}
            {choixCreerFournisseur && <FormCreerFournisseur />}
            {choixPageAide && <PageAide />}
            {choixVoirLesLots && <AffichageLots/>}
            {choixDernierLot && <AffichageDernierLot/>}
            {choixRappel && <RappelLot/>}
            {choixCharger && <ChargerLot/>}            
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col></Col>
          <Col xs={7}>
            <br />
            {choixProfilFournisseur && <ProfilFournisseur />}            
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col></Col>
          <Col xs={7}>
            <br />
            {choixPageAccueil && <PageAccueil/>}
          </Col>
          <Col></Col>
        </Row>
      </Container>

      <Container>
        <Row>
          <Col></Col>
          <Col xs={9}>
            {choixGraphe && <PreparerEtAussiAfficherGraphe/>}

          </Col>
          <Col></Col>
        </Row>
      </Container>


      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Initialisation</Modal.Title>
        </Modal.Header>
        <Modal.Body>{msgModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal> 
    </>
  );
}
